export const relationships = state => state.contactReducer.person.reducer.relationShips
